<template>
  <div class="re-coating-page">
    <!-- 内容描述和图片区域 - 图片在下方 -->
    <div class="content-wrapper">
      <div class="recoating-text-content">
        <!-- 标题部分 -->
        <div class="main-title">{{ $t('series.recoating_desc1') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc2') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc3') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc4') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc5') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc6') }}</div>
        <div class="text-line">{{ $t('series.recoating_desc7') }}</div>
      </div>
      <div class="image-content">
        <img src="../../static/series/cutbed/recoating.png" class="device-img">
      </div>
      <div class="image-content2">
        <img class="recoating-img2" src="../../static/series/cutbed/recoating2.png" alt="">
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ReCoatingPage',
  data() {
    return {
      // 可根据实际情况调整，这里只是示例
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set('.recoating-text-content', {
        x: -150,
        y: 300
      })
      // 时间线
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.image-content',
          start: 'top 80%',
          end: 'bottom 50%',
          markers: false,
          once: true,
          // scrub: 0.8,
          toggleActions: 'play none none none'
        }
      })

      masterTimeline.from('.recoating-text-content', {
        opacity: 0,
        y: 500,
        duration: 2,
        scale: 0.3,
        transformOrigin: "0% 100%"
      }, 0)

      masterTimeline.from('.image-content', {
        opacity: 0,
        x: 500,
        duration: 2,
        transformOrigin: "0% 100%"
      }, 0)

      //image-content2
      masterTimeline.from('.image-content2', {
        opacity: 0,
        y: -200,
        duration: 2,
      }, 0.5)
      // masterTimeline.to(['.image-content', '.recoating-text-content'], {
      //   opacity: 0,
      //   y: -500
      // })

    })
  }
};
</script>

<style scoped>
.re-coating-page {
  width: 100%;
  padding: 50px 20px;
  box-sizing: border-box;
  background-color: #fff;
  margin-top: 50px;
  position: relative;
  height: 800px;
}

.main-title {
  font-size: 2.5em;
  color: #4e95d9;
  margin-bottom: 40px;
  text-align: left; /* 标题左对齐 */
}

.sub-title {
  color: #337ab7;
}

.content-wrapper {
  height: 0;
  display: flex;
  flex-direction: column; /* 垂直排列，文本在上，图片在下 */
  //margin-top: 30px;
  width: 100%;
}

.recoating-text-content {
  margin: 0 auto;
  margin-bottom: 30px; /* 文本与图片之间的间距 */
  text-align: left; /* 文本区域整体左对齐 */
}

/* 文本行样式 */
.text-line {
  width: 100%; /* 每个文本行占满宽度 */
  font-size: 1.2em;
  color: #333;
  //line-height: 1.8;
  text-align: left;
  /* 便于移动调整的样式 */
  transition: all 0.3s ease;
}

.image-content {
  position: absolute;
  width: 100%; /* 图片容器占满宽度 */
  display: flex;
  justify-content: center; /* 图片水平居中 */
  margin-top: 20px;
  top: 65%;
}

.image-content2 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 78%;
  left: 13.5%;
  img {
    height: 19%;

  }
}

.device-img {
  width: 90%; /* 图片占屏幕80%宽度 */
  height: auto;
}

/* 响应式适配 */
@media (max-width: 768px) {
  .device-img {
    max-width: 90%; /* 小屏幕下图片宽度稍大 */
  }

  .text-line {
    font-size: 15px; /* 小屏幕文本稍小 */
  }
}
</style>

